import React, {useCallback, useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useParams} from "react-router-dom";
import {toast} from "react-toastify";
import {addDays, format, parseISO} from "date-fns";

import {Button, OperationButton} from "../../styles-components/Buttons";
import {Container} from "../../styles-components/Container";
import {
  Column,
  Form,
  FormHeader,
  Label,
  Row,
  RowOption,
  RowValueButtons,
  ErrorMessage,
} from "../../styles-components/FormItens";
import {RowDate, RowTotal, InputDisabled, Subtitle} from "./styles";
import LoadingEffect from "../../components/LoadingEffect";

import inputFormat from "../../utils/inputFormat";
import {apiPedidos} from "../../services/data";
import UseRedirectView from "../../utils/UseRedirectView";

const EditPedidos = () => {

  const state = {
    orderTotal: 0
  }

  const [isSmallView, setIsSmallView] = useState(false);
  const [costCentersExists, setCostCentersExists] = useState(false);
  const [buttonShow, setButtonShow] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [dataApi, setDataApi] = useState({});
  const {
    register,
    watch,
    formState: {errors},
    handleSubmit,
    setValue,
    getValues,
  } = useForm();
  const {id} = useParams();

  const watchIsPeriod = watch("is_period");

  useEffect(() => {
    setIsLoading(true);
    if (window.innerWidth <= 570) {
      setIsSmallView(true);
    }
    fetchOrder();
  }, []);

  useEffect(() => {
    if (watchIsPeriod !== "" && watchIsPeriod !== undefined) {
      if (watchIsPeriod) {
        setButtonShow(true);
        if (costCentersExists)
          toast.warning(
            "Ao selecionar essa opção, os valores de centros de custo serão replicados para o período."
          );
      }
    }
  }, [watchIsPeriod]);

  async function fetchOrder() {
    try {
      await apiPedidos.show(id).then((response) => {
        setDataApi(response.data.data);
        if (
          response.data.data["order"].quantity_cost_centers &&
          response.data.data["order"].quantity_cost_centers.length > 0
        )
          setCostCentersExists(true);
      });
      setIsLoading(false);
    } catch (err) {
      toast.error(
        "Infelizmente, não foi possível carregar o pedido. Tente novamente."
      );
    }
  }

  const handleUpdateValueTotal = () => {
    setValue('total', document.getElementById('total').value)
  };

  const sunTotal = event => {
    let ammount = 0;
    dataApi["order"].quantity_cost_centers.map((constCenter, key) => {
      let inputValue = document.getElementById('empresa' + key).value;
      if (inputValue && !isNaN(inputValue)) {
        ammount += parseInt(inputValue);
      }
    })
    state.orderTotal = ammount;
    document.getElementById('total').value = state.orderTotal;
  }

  const handleUpdateTotolPerFactory = (e) => {
    setValue(e.target.id, e.target.value)
  }


  const handleFocus = (event) => {
    event.target.select();
  };


    const onSubmit = async (data) => {
      const requestData = {
        service: data.service,
        data_start: data.date_start,
        is_period: data.is_period,
        note: data.note,
        centerValues: [],
      };

      if (data.coffee_litro_1) {
        requestData.coffee_litro_1 = data.coffee_litro_1;
      }
      if (requestData.is_period) {
        requestData.data_end = data.date_end;
      }



      if (costCentersExists) {
        let total = 0;
        dataApi.order.quantity_cost_centers.map((center,key) => {
          if (data[center.cost_center.name] !== "") {
            total += parseInt(data[center.cost_center.name]);
            requestData.centerValues.push({
              costCenterId: center.cost_center_id,
              id: center.id,
              //quantity: parseInt(data[center.cost_center.name]),
              quantity : document.getElementById('empresa'+key).value
            });
          }
        });
        //requestData.total = total;
        requestData.total = state.orderTotal;
      } else {
        requestData.total = data.total;
      }

      requestData.total = document.getElementById('total').value;

      try {
        await apiPedidos.update(id, requestData);
        toast.success("O pedido foi atualizado com sucesso.");
        if (dataApi["has_role_nutricionista"]) {
          UseRedirectView.to("nutri/pedidos/listagem");
        } else {
          UseRedirectView.to("pedidos/listagem");
        }
      } catch (error) {
        toast.error("Infelizmente não foi possível atualizar o pedido.");
      }
    };

    const handleUpdateInputValue = useCallback(
      (idInput, operator) => {
        var aux = parseInt(getValues(idInput));
        if (operator === "+") {
          setValue(idInput, aux + 1);
        } else {
          if (aux > 0) setValue(idInput, aux - 1);
        }
      },
      [setValue, getValues]
    );




    return (
      <>
        {isLoading ? (
          <LoadingEffect/>
        ) : (
          <Container>
            <FormHeader>
              <h1>Edição de Pedido</h1>
              <Button
                color="--white"
                backgroundColor="--orange"
                onClick={() =>
                  UseRedirectView.to(
                    dataApi["has_role_nutricionista"]
                      ? "nutri/pedidos/listagem"
                      : "pedidos/listagem"
                  )
                }
              >
                Voltar
              </Button>
            </FormHeader>
            <Form method="POST" onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Label>Serviço:</Label>
                <InputDisabled
                  type="text"
                  {...register("service", {
                    required: true,
                    value: dataApi["order"].service.nome,
                  })}
                  disabled={true}
                />
              </Row>
              <RowDate>
                <Label>Data{watchIsPeriod && " Início"}:</Label>
                <InputDisabled
                  type="date"
                  {...register("date_start", {
                    required: true,
                    value: dataApi["order"].date,
                  })}
                  disabled={true}
                />
              </RowDate>
              {watchIsPeriod && (
                <>
                  <RowDate>
                    <Label>Data Final:</Label>
                    <input
                      type="date"
                      min={format(
                        addDays(parseISO(getValues("date_start")), +1),
                        "yyyy-MM-dd"
                      )}
                      {...register("date_end", {required: true})}
                      style={errors.date_end && {...inputFormat}}
                    />
                  </RowDate>
                  {errors.date_end && (
                    <ErrorMessage color="--red">
                      {errors.date_end.message}
                    </ErrorMessage>
                  )}
                </>
              )}
              {/* {dataApi["order"].service.id == "47" && (
              <>
                <Row>
                  <Label htmlFor="time">Horário:</Label>
                  <InputDisabled
                    {...register("time", {
                      value: dataApi["order"].time,
                      required: { value: true, message: "Informe um hórario" },
                    })}
                    style={errors.time && { ...inputFormat }}
                    type="time"
                    id="time"
                    disabled={true}
                  />
                </Row>
                {errors?.time && (
                  <ErrorMessage color="--red">
                    {errors.time.message}
                  </ErrorMessage>
                )}
              </>
            )} */}
              <RowOption>
                <input
                  type="checkbox"
                  {...register("is_period")}
                  id="is_period"
                />
                <Label htmlFor="is_period">editar período</Label>
              </RowOption>
              {dataApi["order"].service.id === "2" && !costCentersExists && (
                <>
                  <Row>
                    <Label htmlFor="coffee_litro_1">Café Litro 1:</Label>
                    {!isSmallView ? (
                      <input
                        {...register("coffee_litro_1", {
                          value: dataApi["order"].quantity_order[0].quantity,
                          required: {
                            value: true,
                            message: "Informe uma quantidade",
                          },
                          min: {
                            value: 1,
                            message: "Informe uma quantidade maior que 0",
                          },
                        })}
                        style={errors.e_litro_1 && {...inputFormat}}
                        type="number"
                        id="coffee_litro_1"
                      />
                    ) : (
                      <RowValueButtons>
                        <OperationButton
                          type="button"
                          onClick={() =>
                            handleUpdateValueCoffee("coffee_litro_1", "-")
                          }
                        >
                          -
                        </OperationButton>
                        <input
                          {...register("coffee_litro_1", {
                            value: dataApi["order"].quantity_order[0].quantity,
                            required: {
                              value: true,
                              message: "Informe uma quantidade",
                            },
                            min: {
                              value: 1,
                              message: "Informe uma quantidade maior que 0",
                            },
                          })}
                          style={errors.coffee_litro_1 && {...inputFormat}}
                          type="number"
                          id="coffee_litro_1"
                        />
                        <OperationButton
                          type="button"
                          onClick={() =>
                            handleUpdateValueCoffee("coffee_litro_1", "+")
                          }
                        >
                          +
                        </OperationButton>
                      </RowValueButtons>
                    )}
                  </Row>
                  {errors?.coffee_litro_1 && (
                    <ErrorMessage color="--red">
                      {errors.coffee_litro_1.message}
                    </ErrorMessage>
                  )}
                  {/* <Row>
                  <Label htmlFor="coffee_litro_2">Café Litro 2:</Label>
                  {!isSmallView ? (
                    <input
                      {...register("coffee_litro_2", {
                        value: dataApi["order"].quantity_order[1].quantity,
                        required: {
                          value: true,
                          message: "Informe uma quantidade",
                        },
                        min: {
                          value: 1,
                          message: "Informe uma quantidade maior que 0",
                        },
                      })}
                      style={errors.coffee_litro_2 && { ...inputFormat }}
                      type="number"
                      id="coffee_litro_2"
                    />
                  ) : (
                    <RowValueButtons>
                      <OperationButton
                        type="button"
                        onClick={() =>
                          handleUpdateValueCoffee("coffee_litro_2", "-")
                        }
                      >
                        -
                      </OperationButton>
                      <input
                        {...register("coffee_litro_2", {
                          value: dataApi["order"].quantity_order[1].quantity,
                          required: {
                            value: true,
                            message: "Informe uma quantidade",
                          },
                          min: {
                            value: 1,
                            message: "Informe uma quantidade maior que 0",
                          },
                        })}
                        style={errors.coffee_litro_2 && { ...inputFormat }}
                        type="number"
                        id="coffee_litro_2"
                      />
                      <OperationButton
                        type="button"
                        onClick={() =>
                          handleUpdateValueCoffee("coffee_litro_2", "+")
                        }
                      >
                        +
                      </OperationButton>
                    </RowValueButtons>
                  )}
                </Row>
                {errors?.coffee_litro_2 && (
                  <ErrorMessage color="--red">
                    {errors.coffee_litro_2.message}
                  </ErrorMessage>
                )} */}
                </>
              )}

              {costCentersExists && (
                <Column>
                  <Subtitle>Centros de Custo:</Subtitle>
                  {dataApi["order"].quantity_cost_centers.map((center, k) => (
                    <section key={center.id}>
                      <RowTotal>
                        <Label isToUpper={true}>{center.cost_center.name}:</Label>

                        <input
                          id = {'empresa'+k}
                          type="number"
                          {...register(center.cost_center.name, {
                            required: {
                              value: true,
                              message: "Informe um valor para este campo",
                            },
                            min: {
                              value: 0,
                              message: "Informe uma quantidade maior que -1",
                            },
                            value: (center.quantity) ? center.quantity : 0,
                          })}
                          style={
                            errors[center.cost_center.name] && {
                              ...inputFormat,
                            }
                          }

                          onBlur={sunTotal}
                          onChange={e => {
                            sunTotal(e);
                            handleUpdateValueTotal();
                            handleUpdateTotolPerFactory(e)
                          }}
                          onFocus={handleFocus}

                        />

                      </RowTotal>
                      {errors[center.cost_center.name] && (
                        <ErrorMessage color="--red">
                          {errors[center.cost_center.name].message}
                        </ErrorMessage>
                      )}
                    </section>
                  ))}
                </Column>
              )}

              <>
                <RowTotal>
                  <Label>Total:</Label>
                  <input
                    id='total'
                    name='total'
                    type="number"
                    {...register("total", {
                      required: {
                        value: true,
                        message: "Informe um valor para este campo",
                      },
                      min: {
                        value: 1,
                        message: "Informe uma quantidade maior que 0",
                      },
                      value: dataApi["order"].quantity_order[0].quantity,
                    })}
                    style={errors.total && {...inputFormat}}
                    className={'form-control'}
                    readOnly={true}
                    onChange={handleUpdateValueTotal}
                  />
                </RowTotal>
                {errors.total && (
                  <ErrorMessage color="--red">
                    {errors.total.message}
                  </ErrorMessage>
                )}
              </>

              <Column>
                <Label>Observação:</Label>
                <textarea
                  {...register("note", {value: dataApi["order"].note})}
                  style={errors.note && {...inputFormat}}
                ></textarea>
              </Column>
              {buttonShow && (
                <Button
                  type="submit"
                  color="--white"
                  backgroundColor="--orange"
                  align="flex-end"
                >
                  Salvar
                </Button>
              )}
            </Form>
          </Container>
        )}
      </>
    );
  };

export default EditPedidos;
